import { CrowdStrike } from '../models/CrowdStrike';

export class CrowdStrikeMapper {
  mapGQLModel(data: any): CrowdStrike {
    return new CrowdStrike(data.baseUrl, data.clientId, data.clientSecret);
  }
}
